<div class="app-works-main-container" *ngIf="showEmptyHeader">
    <div class="app-works-header">
        <img
            src="../../../assets/img/welltrack-logos/well-track-white-logo.svg"
            alt="welltrack-logo" />
        <div class="app-works-header-bg">
            <svg-icon icon="app-works-header-bg"></svg-icon>
        </div>
    </div>
</div>
<div class="app-l-page-wrap">
    <div
        id="page-assessment"
        class="page-assessment-section"
        [ngClass]="{ submitLoader: showAnimation }">
        <div
            class="app-l-assesment__question-base"
            *ngIf="isLoaded && !showIntro">
            <div class="app-l-assesment__q-header">
                <h3 class="app-c-heading--h3" aria-live="polite">
                    <span class="questionTitle" translate>das.question</span>
                    <span class="questionNumber">{{ this.active + 1 }}</span>
                </h3>
                <!-- <div class="app-l-assesment__q-progress">
                    <div class="app-c-progress-bar"><div class="app-c-progress-bar__fill" [style.width.%]="progress"></div></div></div>
                </div> -->
            </div>

            <div class="app-l-assesment__q-body page-section-content">
                <div class="app-l-assesment__question">
                    <div
                        class="app-l-assesment__qes-block"
                        *ngFor="let question of questions; let i = index"
                        [ngClass]="{ active: active === i }">
                        <div
                            class="intro-content"
                            *ngIf="
                                question['Group'] == 'intro-question-crafft' &&
                                question.isEnabled
                            ">
                            <span class="question-title">
                                <h5
                                    aria-live="polite"
                                    class="app-c-heading--h4 qn-sub-title">
                                    {{
                                        'assessments.crafft.introQuestionTitle'
                                            | translate
                                    }}
                                </h5>
                            </span>
                        </div>
                        <div>
                            <h4
                                aria-live="polite"
                                *ngIf="
                                    question.questionType != 'resourceQuestion'
                                "
                                class="app-c-heading--h4">
                                {{ question.Comment }}
                            </h4>
                            <h4
                                translate
                                *ngIf="
                                    question['Type'] == 3 &&
                                    question.questionType == 'resourceQuestion'
                                "
                                class="app-c-heading--h4">
                                das.resourceQuestionTitle
                            </h4>
                            <div
                                [ngClass]="'wt-auto-question-buttons-' + i"
                                class="app-l-question__wrap"
                                [attr.role]="
                                    question['Type'] == 1
                                        ? 'radiogroup'
                                        : 'group'
                                "
                                [attr.aria-labelledby]="'question-' + i">
                                <div
                                    class="app-l-question__block"
                                    *ngFor="
                                        let option of question.options;
                                        let j = index
                                    ">
                                    <!-- Checkbox for Type = 2 (Multiple Options) -->
                                    <label
                                        *ngIf="question['Type'] == 2"
                                        [for]="option.ID"
                                        class="app-c-custom__select"
                                        [ngClass]="{
                                            active: isSelected(i, option.ID),
                                        }"
                                        role="checkbox"
                                        [attr.aria-label]="option.Comment"
                                        [attr.aria-checked]="
                                            isSelected(i, option.ID)
                                        "
                                        [attr.for]="option.ID">
                                        <input
                                            type="checkbox"
                                            [id]="option.ID"
                                            [name]="question.ID"
                                            [checked]="isSelected(i, option.ID)"
                                            class="sr-only"
                                            (click)="
                                                onSelectionChange(
                                                    i,
                                                    option.OptionValue,
                                                    question,
                                                    option.ID
                                                )
                                            "
                                            style="display: none" />

                                        <span
                                            class="app-c-custom__select-text"
                                            >{{ option.Comment }}</span
                                        >
                                        <svg-icon
                                            icon="tick-circle"
                                            class="app-c-custom__select-icon"></svg-icon>
                                    </label>

                                    <!-- Radio Button for Type = 1 (Single Option) -->
                                    <label
                                        *ngIf="question['Type'] == 1"
                                        role="radio"
                                        [attr.for]="option.ID"
                                        [for]="option.ID"
                                        class="app-c-custom__select"
                                        [attr.aria-label]="option.Comment"
                                        [ngClass]="{
                                            active:
                                                question.answer.value ===
                                                option.OptionValue,
                                        }"
                                        [attr.aria-checked]="
                                            question.answer.value ===
                                            option.OptionValue
                                        ">
                                        <input
                                            type="radio"
                                            [id]="option.ID"
                                            [name]="question.ID"
                                            class="sr-only"
                                            [checked]="
                                                question.answer.value ===
                                                option.OptionValue
                                            "
                                            (click)="
                                                onSelectionChange(
                                                    i,
                                                    option.OptionValue,
                                                    question,
                                                    option.ID
                                                )
                                            "
                                            style="display: none" />

                                        <span
                                            class="app-c-custom__select-text"
                                            >{{ option.Comment }}</span
                                        >
                                        <svg-icon
                                            icon="tick-circle"
                                            class="app-c-custom__select-icon"></svg-icon>
                                    </label>

                                    <label
                                        class="app-c-custom__select"
                                        *ngIf="question['Type'] == 3"
                                        [ngClass]="{ active: option.checked }">
                                        <input
                                            type="checkbox"
                                            [id]="option.ID"
                                            [name]="question.ID"
                                            [checked]="option.checked"
                                            (click)="
                                                onSelectionChange(
                                                    i,
                                                    option.OptionValue,
                                                    question,
                                                    option.ID,
                                                    option
                                                )
                                            "
                                            style="display: none" />
                                        <span
                                            class="app-c-custom__select-text"
                                            >{{ option.Comment }}</span
                                        >
                                        <svg-icon
                                            icon="tick-circle"
                                            class="app-c-custom__select-icon"></svg-icon>
                                    </label>

                                    <!-- Textarea for Type = 5 -->
                                    <div
                                        *ngIf="question['Type'] == 5"
                                        class="app-c-form-control-wrapper"
                                        [attr.aria-label]="
                                            'thoughtDiary.steps.0.inputText'
                                                | translate
                                        ">
                                        <textarea
                                            [id]="option.ID"
                                            class="app-c-form-control"
                                            [(ngModel)]="question.answer.value"
                                            placeholder="{{
                                                'thoughtDiary.steps.0.inputText'
                                                    | translate
                                            }}"
                                            [disabled]="
                                                question.answer.fieldDisabled
                                            "
                                            [ngClass]="{
                                                'field-disabled':
                                                    question.answer
                                                        .fieldDisabled,
                                            }"
                                            (input)="
                                                onSelectionChange(
                                                    i,
                                                    option.OptionValue,
                                                    question,
                                                    option.ID
                                                )
                                            ">
                                        </textarea>
                                    </div>

                                    <div
                                        class="app-c-form-control-wrapper"
                                        *ngIf="question['Type'] == 8"
                                        [attr.aria-label]="
                                            'assessments.crafft.enterDays'
                                                | translate
                                        ">
                                        <div
                                            class="input-item age-input-section">
                                            <input
                                                placeholder="{{
                                                    'assessments.crafft.enterDays'
                                                        | translate
                                                }}"
                                                floating
                                                type="number"
                                                [min]="0"
                                                (input)="
                                                    onSelectionChange(
                                                        i,
                                                        $event.target.value,
                                                        question,
                                                        option.ID
                                                    )
                                                " />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="app-l-assesment__question-footer">
                    <div class="app-l-aq__f-wrap">
                        <button
                            tabindex="0"
                            class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                            (click)="setPreviousActive()"
                            [ngClass]="{ 'btn-disabled': active === 0 }"
                            [disabled]="active === 0"
                            translate>
                            <svg-icon icon="arrow-left"></svg-icon>
                            <span translate>das.previous</span>
                        </button>

                        <button
                            tabindex="0"
                            *ngIf="isShowNextBtn()"
                            [ngClass]="{
                                'btn-disabled':
                                    !showIntro && !questions[active].isAnswered,
                            }"
                            class="app-c-btn app-c-btn--primary app-c-btn--curve"
                            (click)="setNextActive()"
                            [disabled]="
                                !showIntro && !questions[active].isAnswered
                            "
                            translate>
                            <span translate>das.next</span>
                            <svg-icon icon="arrow-right"></svg-icon>
                        </button>

                        <button
                            tabindex="0"
                            *ngIf="!showIntro && isShowFinishBtn()"
                            class="app-c-btn app-c-btn--primary app-c-btn--curve"
                            (click)="onSubmit()"
                            [ngClass]="
                                checkAllAnswered()
                                    ? 'btn-primary'
                                    : 'fn-btn-disabled'
                            "
                            [disabled]="!checkAllAnswered()">
                            <span translate>{{
                                'assessments.' + quizType + '.finish'
                            }}</span>
                            <svg-icon icon="tick"></svg-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="app-l-assessment__instruction" *ngIf="showIntro">
            <div class="app-l-assessment__i-body">
                <div class="app-l-assessment__icon">
                    <img
                        [src]="
                            './assets/img/icons-svg/assessments/assessment_type_' +
                            quizType +
                            '.svg'
                        " />
                </div>
                <div class="app-l-assessment__content">
                    <h3 class="app-c-heading--h3" translate>
                        {{ 'assessments.' + quizType + '.title' }}
                    </h3>
                    <div class="app-l-assessment__content-block">
                        <h4 translate>assessments.instructions</h4>
                        <ng-container *ngIf="quizType !== 'dass'">
                            <p translate aria-live="polite">
                                {{ 'assessments.' + quizType + '.intro' }}
                            </p>
                            <p
                                *ngIf="assessmenttranslation?.subIntro"
                                translate
                                aria-live="polite"
                                tabindex="0">
                                {{ 'assessments.' + quizType + '.subIntro' }}
                            </p>
                            <div class="course-line"></div>
                            <span class="title" translate
                                >assessments.crafft.notice.title</span
                            >
                            <p class="description" translate>
                                {{
                                    'assessments.' +
                                        quizType +
                                        '.notice.content1'
                                }}
                            </p>
                            <p class="description" translate>
                                {{
                                    'assessments.' +
                                        quizType +
                                        '.notice.content2'
                                }}
                            </p>
                            <p class="description" translate>
                                {{
                                    'assessments.' +
                                        quizType +
                                        '.notice.content3'
                                }}
                                <span class="course-link-title" translate>
                                    {{ 'crafft@childrens.harvard.edu' }}
                                </span>
                            </p>
                            <p class="description" translate>
                                {{
                                    'assessments.' +
                                        quizType +
                                        '.notice.content4'
                                }}
                                <a
                                    class="course-link"
                                    href="http://www.crafft.org"
                                    target="_blank"
                                    rel="noopener"
                                    translate
                                    ><u>{{ 'http://www.crafft.org ' }}</u></a
                                >
                            </p>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="app-l-assessment__i-footer">
                <button
                    class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                    (click)="goBack()">
                    <svg-icon icon="arrow-left"></svg-icon>
                    <span translate>das.back</span>
                </button>
                <button
                    autofocus
                    aria-live="polite"
                    tabindex="0"
                    class="app-c-btn app-c-btn--primary app-c-btn--curve"
                    (click)="setIntro(false)"
                    translate>
                    das.start
                </button>
            </div>
        </div>
    </div>
</div>

<div class="app-c-loader" *ngIf="showAnimation">
    <div class="app-c-loader__inside">
        <div class="app-c-loader__image">
            <img alt="select" src="/assets/img/loader.gif" />
        </div>
        <div class="app-c-loader__content">
            <h4 class="app-c-heading--h4">Hold on!</h4>
            <p>Your assessment is almost complete</p>
        </div>
    </div>
</div>
